// tslint:disable-next-line:max-line-length
import { Component, OnInit, ViewChild, ElementRef, Input, AfterContentInit, AfterContentChecked, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'scrollable',
  templateUrl: './scrollable.component.html',
  styleUrls: ['./scrollable.component.scss']
})
export class ScrollableComponent implements OnInit, AfterContentInit, AfterContentChecked {
  @Input('range') range = 20;
  @Input() containerHeight: number;
  @Output() scrolled = new EventEmitter<any>();
  @ViewChild('wrapper', { read: ElementRef, static: true }) wrapper: ElementRef;

  scrollTop = 0;
  scrollHeight = 0;
  height = 0;

  expand = false;

  showTopIndicator = false;
  showBottomIndicator = false;

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    this.onScroll();
  }

  ngAfterContentChecked() {
    this.onScroll();
  }

  onScroll() {
    this.scrollHeight = this.wrapper.nativeElement.scrollHeight;
    this.height = this.wrapper.nativeElement.offsetHeight;
    this.scrollTop = this.wrapper.nativeElement.scrollTop;
    this.renderIndicators();
  }

  onScrolled() {
    this.scrolled.emit(event);
  }

  toggleExpand() {
    this.expand = !this.expand;
  }

  scrollDown(): boolean {
    this.wrapper.nativeElement.scrollTop += this.height;
    return false;
  }

  scrollUp(): boolean {
    this.wrapper.nativeElement.scrollTop -= this.height;
    return false;
  }

  renderIndicators() {
    this.showTopIndicator = this.scrollTop > this.range;
    this.showBottomIndicator = this.scrollTop < this.scrollHeight - this.height - this.range;
  }
}
